module.exports = __webpack_public_path__ + "static/img/point_order.3af26ad4.png";